import axios from 'axios';
import { createAuthEndpoints } from './endpoints/auth';
import { createAuthSession } from './authSession';
import { createBrowserCoordinator } from './sessionCoordinator';
import { bindSessionClient } from './sessionClient';

// Legacy key is retained only until the obsolete callback is removed in T18.
export const TOKEN_KEY = 'mini_erp_token';
const baseURL = import.meta.env.VITE_API_URL || '/api/v1';
const config = { baseURL, timeout: 10000, headers: { 'Content-Type': 'application/json' } };

export const authSession = createAuthSession(createAuthEndpoints(axios.create(config)), createBrowserCoordinator());
export const api = bindSessionClient(axios.create(config), authSession);
